import React from 'react';
import clsx from 'clsx';

import { ReactComponent as ThunderIcon } from 'assets/images/icons/thunder_icon.svg';
import { ReactComponent as ScheduleIcon } from 'assets/images/icons/schedule_icon.svg';

import { ScheduleTab } from '../../domain';

import { useScheduleOrdersTabsLang } from './hooks';

import makeClasses from './ScheduleOrdersTabs.style';

interface Props {
  value: ScheduleTab;
  onChange: (tab: ScheduleTab) => void;
  inProgressCount?: number;
  scheduledCount?: number;
}

export function ScheduleOrdersTabs(props: Props) {
  const { value, onChange, inProgressCount, scheduledCount } = props;

  const lang = useScheduleOrdersTabsLang();
  const _classes = makeClasses();

  const isInProgressActive = value === ScheduleTab.InProgress;
  const isScheduledActive = value === ScheduleTab.Scheduled;

  return (
    <div className={_classes.root} role='tablist'>
      <button
        type='button'
        role='tab'
        aria-selected={isInProgressActive}
        onClick={() => onChange(ScheduleTab.InProgress)}
        className={clsx(_classes.tab, {
          [_classes.active]: isInProgressActive,
        })}
      >
        <ThunderIcon aria-hidden='true' className={_classes.icon} />
        <span>{lang.inProgressTab}</span>
        {!!inProgressCount && (
          <span
            className={clsx(_classes.badge, {
              [_classes.badgeActiveInProgress]: isInProgressActive,
            })}
          >
            {inProgressCount}
          </span>
        )}
      </button>
      <button
        type='button'
        role='tab'
        aria-selected={isScheduledActive}
        onClick={() => onChange(ScheduleTab.Scheduled)}
        className={clsx(_classes.tab, {
          [_classes.active]: isScheduledActive,
        })}
      >
        <ScheduleIcon aria-hidden='true' className={_classes.icon} />
        <span>{lang.scheduledTab}</span>
        {!!scheduledCount && (
          <span
            className={clsx(_classes.badge, {
              [_classes.badgeActiveScheduled]: isScheduledActive,
            })}
          >
            {scheduledCount}
          </span>
        )}
      </button>
    </div>
  );
}
